import { Route, Navigate } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { SystemUserOnly } from "@/shared/components/SystemUserOnly";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";

import { EventsPage } from "./EventsPage";

export const EventsRoutes = () => [
  <Route
    key={"/"}
    index
    loader={loadSearchTablePreferences(
      queryClient,
      "event_search_table_preferences",
    )}
    element={
      <SystemUserOnly fallback={<Navigate to="/search" replace />}>
        <EventsPage />
      </SystemUserOnly>
    }
  />,
];
